var Authentication = function(options){
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

Authentication.prototype = {
    // shorthand for using prototype
    constructor : Authentication,

    // default options
    defaults : {
        form : ''
    },

    createAccountForm : '',

    loginForm : '',

    init : function(){
        var _this = this;

        // set the form id
        _this.settings.form = $('#form-id').val();

        // Reset password modal JS
        $('.resend-password-email').on('click', function(e) {
            var $container = $(this).closest('.login-form-container');

            e.preventDefault();
            _this.loginForm = $container;

            var postString = buildPostString($(this).closest('.forgot-password-form'));
            postString += '&resendEmail=1';

            $.fn.qpost({
                url : url('resend_password', [$('#form-id').val()]),
                csrf : true,
                data : postString,
                success : function(data) {
                    if (data.success) {
                        _this.displayMessage('If an account with your email address was found in our system, a password reset email will be sent.', "success", _this.loginForm);
                    } else {
                        _this.displayMessage(data.errors, "error", _this.loginForm);
                    }
                },
                failure : function() {
                    _this.displayMessage('We were not able to resend the email. Please try again.', "error", _this.loginForm);
                },
            });

        });

        // login page has two login forms (header and body), so this makes things simpler
        $('.login-formselection').on('change', function() {
            $('.login-formselection').val ( $(this).val() );
        });

        // bind logout
        $('.logout-button').on('click', function(e) {
            QGIV.Account.logout(function(response) {
                window.location.href = url('pfp', [response.form,response.registrationId]);
            });

            e.preventDefault();
        });

        $('.login-reset-toggle').on('click', function(e) {
            var $container = $(this).closest('.login-form-container'),
                $target = $container.find('.login-form, .forgot-password-form');

            e.preventDefault();
            $target.slideToggle();
        });

        QGIV.Account.onLoginSuccess = function(response) {
            _formselection = $('.login-formselection').val();

            // now log in to registration
            if ( response.accountId ) {
                var postString = 'accountLogin=1&accountId=' + response.accountId;

                if ( _formselection && _formselection.length > 0 ) {
                    postString += '&accountLogin=1&formToLogin=' + _formselection;
                }

                // -------------------------------------------------------------------------
                // NOTE: Standard P2P with the Redesigned Donation form use the new endpoint.
                // With this endpoint participant data is also retrieved on login which means
                // we just need to redirect instead of making a second network call.
                // -------------------------------------------------------------------------
                const isStandardP2PRedesignedDonationForm =
                    $("#donation-form-type").length &&
                    $("#donation-form-type").val().length &&
                    $("#donation-form-type").val() === "1";

                if (isStandardP2PRedesignedDonationForm) {
                    _this.redirectLoggedInParticipant(response);
                } else {
                    _this.processLogin(postString);
                }

            } else if ( response.errors ) {
                _this.displayMessage(response.errors, 'error', _this.loginForm)
            } else {
                _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
            }
        };

        QGIV.Account.onLoginFail = function(response) {
            if ( response.errors ) {
                _this.displayMessage(response.errors, 'error', _this.loginForm);
            } else {
                _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
            }
        };

        QGIV.Account.onCreateAccountSuccess = function(response) {
            // now log in to registration
            if ( response.accountId ) {
                var postString = 'accountLogin=1&accountId=' + response.accountId;

                _this.processLogin(postString);
            } else if ( response.errors ) {
                _this.displayMessage(response.errors, 'error', _this.loginForm);
            } else {
                _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
            }
        };

        QGIV.Account.onCreateAccountFail = function(response) {
            if ( response.errors ) {
                _this.displayMessage(response.errors, 'error', _this.loginForm);
            } else {
                _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
            }
        };

        // bind our login button
        $('.login-button').on('click', function(e) {
            var $container = $(this).closest('.login-form-container'),
                _username = encodeURIComponent($container.find('.login-email').val()),
                _password = encodeURIComponent($container.find('.login-password').val());

            _this.loginForm = $container;

            // prevent double processing
            if ( QGIV.Account.processing ) return false;
            QGIV.Account.processing = true;

            if ( $container.find('.login-formselection').val() ) {
                _formselection = $container.find('.login-formselection').val();

                var errors = _this.validateLogin(_username, _password, _formselection);
            } else {
                var errors = _this.validateLogin(_username, _password);
            }

            if (errors.length > 0) {
                QGIV.Account.processing = false;
                _this.displayMessage(errors, "error", _this.loginForm);
            } else {
                var postString = "username=" + _username;
                    postString += "&password=" + _password;
                    postString += '&p2pRegistration=1&form=' + QGIV.Form.id;

                QGIV.Account.login(postString)
                    .done(function(response){
                        QGIV.Account.processing = false;
                        // fundhub login performs two requests, one to log into the account
                        // and another to log in to their registration for a particular campaign
                        // (if registered for more than one). Upon login, the BE generates
                        // a new csrf token. In order to avoid validation errors, we need to maintain
                        // parity between the csrf token in the form and the one in the session.
                        if(response.donorAccount.csrfToken.length) {
                            $("#csrfToken").val(response.donorAccount.csrfToken);
                        }
                    });
            }

            e.preventDefault();
        });

        // init facebook sdk
        UI.vendor.facebook(function(){
            // bind facebook login
            $('.js-facebook-login').on('click', function() {
                _this.loginForm = $(this).closest('.social-login-container');
                QGIV.Account.facebookSignin();
            });
        }, QGIV.Form.fbAppID);

        $('.g-signin2').on('click', function() {
            _this.loginForm = $(this).closest('.social-login-container');
            $(this).addClass('login-instantiated');
        });

        // bind twitter login
        $('.js-twitter-login').on('click', function() {
            _this.loginForm = $(this).closest('.social-login-container');
            _this.loginViaTwitter();
        });

        // the account messenger sets up communication between our page and the embedded account iframe
        QGIV.Account.Messenger = new PostMessage({
            onReceive : function(event, message){
                var message = QGIV.Utilities.parseJSON(message);

                const isStandardP2PRedesignedDonationForm =
                    $("#donation-form-type").length &&
                    $("#donation-form-type").val().length &&
                    $("#donation-form-type").val() === "1";

                if (!message || isStandardP2PRedesignedDonationForm) return;

                if ( message.event == 'destroy' ) {
                    QGIV.Account.destroyAccountFrame();
                } else if ( message.event == 'login' ) {
                    QGIV.Account.destroyAccountFrame();

                    // we're going to refresh the page with the account ID
                    if ( message.data.account ) {
                        // send another AJAX call to grab the registration
                        var postString = '&role=individual&beginRegistration=1&account=' + message.data.account;

                        // check if the registration is coming from team, etc.
                        if ( $('.js-registration-referrer').length ) {
                            postString += '&referrer_type=' + $('#registration-referrer-type').val() + '&referrer_id=' + $('#registration-referrer-id').val();
                        }

                        $.fn.qpost({
                            url : url('registration_start', [QGIV.Registration.form]),
                            data : postString,
                            success : function(response) {
                                // if we have a success response we redirect the page to registration details
                                // in the backend we've either determined there's a pending registration or we create a new one
                                if ( response && response.success ) {
                                    // if it's a pending registration, we should redirect to the returning users view
                                    var view = response.existingRegistration ? 'existing_registration_details' : 'registration_details';

                                    window.location.href = url(view, [QGIV.Registration.formAlias, response.registrationId]) + '#registration-details-form';
                                } else {
                                    var errors = [];

                                    if ( response.errors ) {
                                        errors = response.errors;
                                    } else {
                                        errors.push("An error has occurred. Please try again.")
                                    }

                                    Message.target = '.registration_details';
                                    Message.post(errors, "error");
                                }
                            },
                            failure : function() {
                                Message.target = '.registration_details';
                                Message.post(QGIV.Registration.errors.registration, "error");
                            },
                        });
                    }
                }
            }
        });

        // the account social messenger handles communication between our social authentication iframe
        // we have to do it like this because the domain comes from "*.qgiv.com" and not necessarily the publicly displayed domain (custom domains)
        QGIV.Account.SocialMessenger = new PostMessage({
            // we use Domain instead of Environment because it guarantees *.qgiv.com
            targetOrigin : QGIV.Domain,
            onReceive : function(event, message){
                var message = QGIV.Utilities.parseJSON(message);

                if ( ! message ) return;

                if ( message.event == 'social-login' ) {
                    _this.loginForm = $('.social-login-container');

                    if ( message.success ) {
                        QGIV.Account.login(message);
                    } else if ( message.errors ) {
                        _this.displayMessage(message.errors, 'error', _this.loginForm);
                    } else {
                        _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
                    }
                } else if ( message.event == 'twitter-login' ) {
                    _this.loginForm = $('.social-login-container');
                    _this.loginViaTwitter();
                } else if ( message.event == 'facebook-post-auth' ) {
                    if ( message.errors ) {
                        _this.displayMessage(message.errors, 'error', '.section-header');
                    } else if ( typeof QGIV.SocialAuth !== 'undefined' ) {
                        QGIV.SocialAuth.socialPostingLogin(message);
                    }
                }
            }
        });

        // opens the account iframe based on the href attribute of the link
        $('.js-account-link').on('click', function(e){
            e.preventDefault();

            var accountLink = $(this).attr('href').split('?'),
                pageURL = '';

            pageURL = accountLink[0] + '/embed/';

            // checking to see if we have query params
            if ( accountLink.length > 1 ) {
                pageURL += '?' + accountLink[1];
            }

            QGIV.Account.renderAccountFrame(pageURL);
        });
    },

    displayMessage : function(message, state, location){
        Message.target = location;
        Message.scrollToMessage = false;
        Message.setMessage(message);
        Message.type = state;
        Message.postMessage();
    },

    validateLogin : function(us, pw, fs) {
        var $container = this.loginForm;

        // remove only login form messages
        $container.find('.ui-message').remove();

        var errors = [];

        if (!us || (us.length < 1)) errors.push("Username cannot be empty");
        if (!pw || (pw.length < 1)) errors.push("Password cannot be empty");
        if ( fs && (fs.length < 1)) errors.push("You must select a form");

        return errors;
    },

    loginViaTwitter : function() {
        var _this = this;

        var postString = "loginViaTwitter=1";
            postString += "&redirect_url=" + window.location.origin + window.location.pathname;

        var _url = url('hobnob_login', [_this.settings.form]);

        $.fn.qpost({
            url : _url,
            csrf : true,
            data : postString,
            success : function(data) {
                if (data) {
                    if (data.success && data.redirect) {
                        window.location.href = data.redirect;
                    } else if (data.errors) {
                        _this.displayMessage(data.errors, 'error', _this.loginForm);
                    } else {
                        _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
                    }
                } else {
                    _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
                }
            },
            failure : function() {
                _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
            },
        });
    },

    redirectLoggedInParticipant: (response) => {
        // -------------------------------------------------------------------------
        // NOTE: If you have made it here there has been a successful login attempt.
        // We need to look at the response data to determine where we are sending the
        // user.
        // -------------------------------------------------------------------------
        const _this = this;

        const { participantAccount, donorAccount, accountId } = response;

        const isActiveParticipant =
            participantAccount && Object.keys(participantAccount).length > 0;

        const isAttemptingToLoginWithPreviousEventCredentials =
            isActiveParticipant && participantAccount?.previousParticipantForm
                ? participantAccount.previousParticipantForm.length > 0
                : false;
        const isActiveDonorAccount =
            donorAccount && Object.keys(donorAccount).length > 0;
        const hasDonorAccountOnly =
            !isActiveParticipant &&
            !isAttemptingToLoginWithPreviousEventCredentials &&
            isActiveDonorAccount;
        const myAccountUrl = `${url("account_profile", [accountId])}?org=${
            donorAccount?.orgId
        }&formId=${_this.settings.form}`;

        if (
            isActiveParticipant &&
            !isAttemptingToLoginWithPreviousEventCredentials
        ) {
            if (participantAccount?.pendingRegistration) {
                window.location.href =
                    url("existing_registration_details", [
                        _this.settings.form,
                        participantAccount.registrationId,
                    ]) + "#registration-details-form";
            } else {
                // They have successfully logged in to this event, let's redirect them to the dashboard
                window.location.href = url("pfp_dashboard", [
                    participantAccount.registrationId,
                ]);
            }
        } else if (isAttemptingToLoginWithPreviousEventCredentials) {
            // -------------------------------------------------------------------------
            // NOTE: This user has a participant account with another event within this
            // org. We want to let them know they have registered for a past event but
            // still need to register for this event.
            // -------------------------------------------------------------------------

            // Hide the login form on menu
            $(".js-nav-sign-in-section").addClass("hide-content");

            // Insert donor first name if available for both the menu message and login page message
            if (donorAccount?.contact?.firstName?.length > 0) {
                const $wrongEventName = document.getElementById(
                    "js-wrong-event-message-fname",
                );
                const $wrongEventNamePageView = document.getElementById(
                    "js-wrong-event-message-fname-login-page",
                );
                const firstNameToSet = `, ${donorAccount.contact.firstName}`;

                if ($wrongEventName) {
                    $wrongEventName.innerHTML = firstNameToSet;
                }
                if ($wrongEventNamePageView) {
                    $wrongEventNamePageView.innerHTML = firstNameToSet;
                }
            }

            // Insert previous event name if available for both the menu message and login page message
            const $previousEventName = document.getElementById(
                "js-wrong-event-message-previous-event",
            );
            const $previousEventNamePageView = document.getElementById(
                "js-wrong-event-message-previous-event-login-page",
            );
            const previousEventNameToSet = ` ${participantAccount.previousParticipantForm}`;
            if ($previousEventName) {
                $previousEventName.innerHTML = previousEventNameToSet;
            }
            if ($previousEventNamePageView) {
                $previousEventNamePageView.innerHTML = previousEventNameToSet;
            }

            document
                .querySelector(".my-qgiv-account-link")
                .setAttribute("href", myAccountUrl);
            document
                .querySelector(".my-qgiv-account-link-login-page")
                .setAttribute("href", myAccountUrl);

            // Replace login ui with message prompting to register for this event
            $(".js-wrong-event-message").removeClass("hide-content");
        } else if (hasDonorAccountOnly) {
            // -------------------------------------------------------------------------
            // NOTE: There is no participant account attached to this user, however the
            // user has entered the correct donor account credentials. Let's send them to
            // their Giving Dashboard.
            // -------------------------------------------------------------------------
            window.location.href = myAccountUrl;
        } else {
            location.reload();
        }
    },

    processLogin : function(postString) {
        var _this = this,
            _url = url('hobnob_login', [_this.settings.form]);

        $.fn.qpost({
            url : _url,
            csrf : true,
            data : postString,
            success : function(data) {
                if (data) {
                    if (data.success) {
                        // determine where to redirect
                        if ( $('#form-type').val() !== '5' ) {
                            if (data.pendingRegistration){
                                window.location.href = url('existing_registration_details', [_this.settings.form, data.registrationId]) + '#registration-details-form';
                            } else {
                                window.location.href = url('pfp_dashboard', [data.registrationId]);
                            }
                        } else {
                            location.reload();
                        }
                    } else if (data.errors) {
                        _this.displayMessage(data.errors, 'error', _this.loginForm);
                        QGIV.Account.processing = false;
                    } else if ( data.relatedForms && $('.js-login-formselection').hasClass('hide-content') ) {
                        var $formDropdown = $('.js-login-formselection').find('select');

                        // add the related forms for the user to select
                        for (var i = 0; i < data.relatedForms.length; i++ ) {
                            $formDropdown.append('<option value="' + data.relatedForms[i].id + '">' + data.relatedForms[i].name + '</option>')
                        }

                        // dispay the dropdown
                        $('.js-login-formselection').removeClass('hide-content');
                    } else {
                        _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
                        QGIV.Account.processing = false;
                    }
                } else {
                    _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
                    QGIV.Account.processing = false;
                }
            },
            failure : function() {
                _this.displayMessage("An error has occurred. Please try again.", 'error', _this.loginForm);
                QGIV.Account.processing = false;
            },
        });
    }
}

$(document).ready(function(){
    var login = new Authentication();
});